const ASSET_EXTENSION_RE = /\.(ico|png|jpg|jpeg|svg|webp|gif|json|txt|xml|css|js|map)$/i;

export function isAssetLikeLocationValue(value: unknown): boolean {
  const text = String(value || "").trim();
  if (!text) return false;
  return text.includes("/") || text.includes("\\") || ASSET_EXTENSION_RE.test(text);
}

export function sanitizeLocationValue(value: unknown): string {
  if (typeof value !== "string") return "";
  const text = value.trim();
  return isAssetLikeLocationValue(text) ? "" : text;
}